import jsonToFormData from 'json-form-data';
// eslint-disable-next-line import/no-cycle
import api from '../config/api';

import * as LocalStorageService from './LocalStorageService';

import { formatErrorResponse, formatAuthResponse } from '../utils/response';
import { TYPE_MANUFACTURER } from '../utils/plans';


/* Public functions */

export function setCurrentUser(currentUser) {
  api.setHeaders({
    'Access-Token': currentUser.accessToken.accessToken,
    Client: currentUser.accessToken.client,
    Expiry: currentUser.accessToken.expiry,
    'Token-Type': currentUser.accessToken.tokenType,
    UID: currentUser.accessToken.uid,
  });
  LocalStorageService.setSessionToken(currentUser.accessToken);
}

export function initStoredUser() {
  const currentSessionToken = LocalStorageService.getSessionToken();
  if (currentSessionToken) {
    api.setHeaders({
      'Access-Token': currentSessionToken.accessToken,
      Client: currentSessionToken.client,
      Expiry: currentSessionToken.expiry,
      'Token-Type': currentSessionToken.tokenType,
      UID: currentSessionToken.uid,
    });
    return true;
  }
  return false;
}

export const removeCurrentUser = async () => LocalStorageService.removeSessionToken();

export async function refresh() {
  const wasLogged = initStoredUser();
  let user = null;
  if (wasLogged) {
    const response = await api.post('/account/refresh');
    if (!response.ok) {
      return formatErrorResponse(response);
    }
    user = formatAuthResponse(response);
    setCurrentUser(user);
  }
  return { user, ok: true };
}

export async function login(account) {
  const response = await api.post('/account/sign_in', {
    account,
  });
  if (!response.ok) {
    return formatErrorResponse(response);
  }
  const user = formatAuthResponse(response);
  setCurrentUser(user);
  return { user, ok: true };
}

export async function recoverPassword(account) {
  const response = await api.post('/account/send_reset_password_instructions', {
    account,
  });
  return response;
}

export async function resetPassword(account) {
  const response = await api.post('/account/reset_password', {
    account,
  });
  return response;
}

export async function myPermissions() {
  const response = await api.get('/my_permissions');
  return response;
}

export async function register({ type, ...registerParams }) {
  const url = type === TYPE_MANUFACTURER ? '/manufacturers' : '/vendors';
  const data = jsonToFormData({ [type]: registerParams });
  const config = {
    headers: { 'content-type': 'multipart/form-data' },
  };
  const response = await api.post(url, data, config);
  if (response.ok) {
    return {
      ok: true,
      account: response.data,
    };
  }
  return formatErrorResponse(response);
}



// WEBPACK FOOTER //
// ./src/services/AuthServices.js